import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'
import styles from './Diagramma.module.css'

ChartJS.register(ArcElement, Tooltip)

type DiagrammaData = {
  label: string
  value: number | null
  color: string
}

interface RequestsDiagrammaProps {
  chartData: DiagrammaData[]
  total: number
  paid: number
  unpaid: number
}

const Diagramma: React.FC<RequestsDiagrammaProps> = ({ chartData, total, paid, unpaid }) => {
  const data = {
    labels: chartData.map((item) => item.label),
    datasets: [
      {
        data: chartData.map((item) => item.value),
        backgroundColor: chartData.map((item) => item.color),
        borderWidth: 0,
      },
    ],
  }

  const options = {
    cutout: '65%',
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
  }

  return (
    <div className={styles.diagrammaContainer}>
      <div className={styles.titleBlock}>
        <h3 className={styles.diagrammaTitle}>Заявки</h3>
      </div>
      <div className={styles.diagrammaContent}>
        <div className={styles.diagrammaInfo}>
          <div className={styles.diagrammaInfoBlock}>
            <div>
              <p>Все заявки</p>
            </div>
            <div className={styles.diagrammaInfoValue}>{total}</div>
          </div>
          <div className={styles.diagrammaInfoBlock}>
            <div>
              <p>Оплаченные заявки</p>
            </div>
            <div className={styles.diagrammaInfoValue}>{paid}</div>
          </div>
          <div className={styles.diagrammaInfoBlock}>
            <div>
              <p>Заявки без оплат</p>
            </div>
            <div className={styles.diagrammaInfoValue}>{unpaid}</div>
          </div>
        </div>

        {/* Центр */}
        <div className={styles.diagrammaChart}>
          <Doughnut data={data} options={options} />
        </div>

        {/* Правая часть */}
        <div className={styles.diagrammaLegend}>
          {chartData.map((item) => (
            <div key={item.label} className={styles.diagrammaLegendItem}>
              <div className={styles.diagrammaLegendDot} style={{ backgroundColor: item.color }} />
              <span className={styles.diagrammaLegendLabel}>{item.label}</span>
              <span className={styles.diagrammaLegendValue}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Diagramma
